<template>
  <div>
    <div class="cloud c1"></div>
    <div class="cloud c2"></div>
    <div class="cloud c3"></div>

    <div class="star s1">★</div>
    <div class="star s2">★</div>

    <div class="heart h1">♥</div>
    <div class="heart h2">♥</div>

    <div class="dot d1">•</div>
    <div class="dot d2">•</div>
  </div>
</template>

<style scoped>
.cloud {
  position: absolute;
  background: #ffffffd9;
  border-radius: 999px;
  box-shadow: 12px 4px 0 #ffffffbf;
  z-index: 1;
}
.c1 { width: 70px; height: 30px; top: 26px; left: 18px; }
.c2 { width: 90px; height: 34px; top: 64px; right: 18px; }
.c3 { width: 65px; height: 26px; top: 140px; left: 36px; }

.star {
  position: absolute;
  color: #fff7b6;
  font-size: 16px;
}
.s1 { top: 32px; left: 120px; }
.s2 { top: 110px; right: 120px; }

.heart {
  position: absolute;
  color: #ff9fbf;
  font-size: 16px;
}
.h1 { top: 78px; left: 38px; }
.h2 { top: 180px; right: 42px; }

.dot {
  position: absolute;
  color: #ffffff;
  font-size: 12px;
}
.d1 { top: 52px; right: 70px; }
.d2 { top: 150px; left: 90px; }
</style>
